<template>
  <div class="w-full">
    <div ref="header" class="px-4 py-3">
      <div class="flex flex-col md:flex-row items-center w-full">
        <div class="w-full md:w-1/2 lg:w-2/3">
          <h1 class="text-2xl">Bicycle Built For Two Thousand</h1>
          <p>
            Over 2,000 human voices recorded via the internet<br />assembled to
            sing <i>Daisly Bell</i>.
            <span class="link" @click="showAbout = true"> More info </span>
          </p>
        </div>
        <div
          class="actions flex flex-row items-center justify-start md:justify-end w-full mt-4 md:mt-0 md:w-1/2 lg:w-1/2 whitespace-no-wrap"
        >
          <div class="flex flex-row items-center">
            <div class="font-bold ml-0 md:ml-6 mr-2">Listen to:</div>
            <div>
              <div
                class="people button"
                :class="{ selected: mode === 0 }"
                v-on:click="openVoiceDropdown"
              >
                People ({{ voiceOptions[selectedVoiceIndex] }}) ▾
              </div>
              <div id="voices-dropdown">
                <div
                  v-if="showVoiceDropdown"
                  v-click-outside="() => (showVoiceDropdown = false)"
                >
                  <div
                    v-for="(option, index) in voiceOptions"
                    :key="`voiceOption-${index}`"
                    v-on:click="selectVoice(index)"
                    :class="{ selected: index === selectedVoiceIndex }"
                  >
                    {{ option }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="computer button border-l-0"
              :class="{ selected: mode === 1 }"
              v-on:click="selectComputer"
            >
              Computer
            </div>
          </div>
          <div class="button play ml-2" v-on:click="playing = !playing">
            <span v-if="playing">&#10074;&#10074;</span>
            <span v-else>▶&#xFE0E;</span>
          </div>
        </div>
      </div>
    </div>
    <Player
      :width="playerWidth"
      :height="playerHeight"
      :mode="mode"
      :voiceIndex="selectedVoiceIndex"
      :playing="playing"
      @mousedown="playing = false"
      @openNote="onOpenNote"
      @playChange="onPlayChange"
    />
    <div v-if="!kiosk" ref="footer" class="fixed bottom-0">
      <div class="p-3">
        A project by
        <a href="http://aaronkoblin.com" target="_blank">Aaron Koblin</a> and
        <a href="http://daniel-massey.com" target="_blank">Daniel Massey</a>
      </div>
    </div>
    <transition name="fade">
      <Popup
        v-if="popup.show"
        :noteType="popup.noteType"
        :noteIndex="popup.noteIndex"
        @close="popup.show = false"
      />
    </transition>
    <transition name="fade">
      <About v-if="showAbout" @close="showAbout = false" />
    </transition>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import Player from "@/components/Player";
import Popup from "@/components/Popup";
import About from "@/components/About";

export default {
  name: "Home",

  components: {
    Player,
    Popup,
    About
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  data() {
    return {
      kiosk: false,
      mode: 0,
      selectedVoiceIndex: 0,
      playing: false,
      playerWidth: 0,
      playerHeight: 0,
      showVoiceDropdown: false,
      voiceOptions: [
        "All",
        "Track 1",
        "Track 2",
        "Track 3",
        "Track 4",
        "Track 5",
        "Track 6",
        "Track 7",
        "Track 8",
        "Track 9",
        "Track 10",
        "Track 11",
        "Track 12"
      ],
      popup: {
        show: false,
        noteType: null,
        noteIndex: null
      },
      showAbout: false
    };
  },

  created() {
    window.addEventListener("resize", this.onWindowResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.onWindowResize);
  },

  mounted() {
    if (this.$route.query.kiosk) {
      this.kiosk = true;
    }

    this.onWindowResize();
  },

  methods: {
    openVoiceDropdown() {
      this.showVoiceDropdown = !this.showVoiceDropdown;
    },

    selectVoice(index) {
      this.selectedVoiceIndex = index;
      this.mode = 0;
      this.showVoiceDropdown = false;
      this.playing = false;
    },

    selectComputer() {
      this.mode = 1;
      this.playing = false;
    },

    onWindowResize() {
      this.playerWidth = window.innerWidth;
      const hh = this.$refs["header"].offsetHeight;
      this.playerHeight = window.innerHeight - hh;
    },

    onOpenNote(type, index) {
      this.popup.noteType = type;
      this.popup.noteIndex = index;
      this.popup.show = true;
    },

    onPlayChange(state) {
      if (this.playing !== state) {
        this.playing = state;
      }
    }
  }
};
</script>

<style scoped>
.actions {
  color: #3a3a3a;
}

.people {
  border-top-left-radius: 0.35rem;
  border-bottom-left-radius: 0.35rem;
}

#voices-dropdown {
  width: auto;
  margin-left: 0.25rem;
  height: 0;
  overflow: visible;
}

#voices-dropdown > div {
  position: absolute;
  z-index: 1;
  background: white;
  border-right: 1px solid #999999;
  border-bottom: 1px solid #999999;
  border-left: 1px solid #999999;
}

#voices-dropdown > div > div {
  padding: 0.25rem 1rem;
  cursor: pointer;
}

#voices-dropdown > div > div:hover {
  background: #eaeaea;
}

#voices-dropdown > div > div.selected {
  background: #eaeaea;
}

.computer {
  border-top-right-radius: 0.35rem;
  border-bottom-right-radius: 0.35rem;
  border-left: none;
}

.play {
  width: 4rem;
  border-radius: 0.35rem;
  text-align: center;
}
</style>
